module.exports = "<lfwms-result-data-table [searchService]=\"searchService\" [tableMode]=\"dataService.displayMode\" (buttonActionHandler)=\"buttonService.handleMainButtonPanelActionsForTable($event, widgetConfig.id)\"></lfwms-result-data-table>\n    "


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/components/widget/commodity-advance-sku-widget/commodity-advance-sku-widget.html
// module id = ../../../../../src/app/shared/components/widget/commodity-advance-sku-widget/commodity-advance-sku-widget.html
// module chunks = main